function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" {...props}><path d="M15.493 14.548A7.25 7.25 0 0 1 2.815 8.812h1.518a5.75 5.75 0 0 0 9.763 5.04h-2.082v-1.5h4.229a.75.75 0 0 1 .75.75v4.242h-1.5v-2.796zM5.874 5.81h2.6v1.5H4.82v.002h-.332c-.02 0-.038 0-.057-.002h-.186a.75.75 0 0 1-.75-.75V2.317h1.5V4.57a7.25 7.25 0 0 1 12.177 6.282h-1.52A5.75 5.75 0 0 0 5.874 5.81h.001z" fillRule="nonzero" /></svg>;
});